import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {PreviousMeetingsWidgetPlaceholder} from "./placeholders/previous-meetings-widget.placeholder";

const PreviousMeetingsWidgetAsyncComponent = AsyncComponent(async () => import('./previous-meetings-widget' /* webpackChunkName: "previous-meetings-widget" */ ));

export const PreviousMeetingsWidgetAsync = (props) => {
  return <React.Suspense fallback={<PreviousMeetingsWidgetPlaceholder {...props}/>}>
    <PreviousMeetingsWidgetAsyncComponent {...props}/>
  </React.Suspense>
}
